<template>
  <modal :closeable="false">
    <div class="row button-row">
      <div class="col-4 text-left">
        <outline-button :border="false" @click.prevent="abort" back>
          {{ $t('buttons.back')}}
        </outline-button>
      </div>
      <div class="col-8 text-right">
        <router-link :to="{path: '/signup/login', query: $route.query}" class="button-link">
        {{ $t('buttons.already_have_an_account')}}
        </router-link>
      </div>
    </div>
    <h3 class="title mt-3">{{$t('titles.create_your_account')}}</h3>
    <p><i>{{ $t('labels.provide_information')}}</i></p>
    <form novalidate @submit="checkForm" class="mt-3">
      <div class="form-row">
        <div class="form-wrapper">
          <input-group :label="$t('labels.first_name')" :error="errors.firstName" required>
            <input
            v-model="user.firstName"
            type="text"
            required
            @blur="check('firstName')"
            autocomplete="given-name"
            />
            <small class="error" v-if="errors.firstName">{{errors.firstName}}</small>
          </input-group>

          <input-group :label="$t('labels.last_name')" :error="errors.lastName" required>
            <input
            v-model="user.lastName"
            type="text"
            required
            @blur="check('lastName')"
            autocomplete="family-name"
            />
            <small class="error" v-if="errors.lastName">{{errors.lastName}}</small>
          </input-group>
        </div>
      </div>

      <div class="form-row mt-0" v-if="askCountryState">
        <div class="form-wrapper">
          <input-group :label="$t('labels.country')" :error="errors.country" required>
            <country-select :user="user" required
                            @change="setCountry"
                            @blur="check('country')"/>
            <small class="error" v-if="errors.country">{{ errors.country }}</small>
          </input-group>

          <input-group :label="$t('labels.state')" :error="errors.state" v-if="stateRequired"
                       required>
            <state-select :user="user" required @blur="check('state')"/>
            <small class="error" v-if="errors.state">{{ errors.state }}</small>
          </input-group>

        </div>
      </div>

      <div class="form-row mt-0">
        <div class="form-wrapper">
          <input-group :label="$t('labels.email')" :error="errors.email" required>
            <input
                v-model="user.email"
                type="email"
                required
                @blur="check('email')"
                autocomplete="email"
            />
            <small class="error" v-if="errors.email">{{errors.email}}</small>
          </input-group>
          <input-group :label="$t('labels.password')" :error="errors.password" required>
            <input
                v-model="user.password"
                type="password"
                required
                @blur="check('password')"
                autocomplete="new-password"
            />
            <small class="error" v-if="errors.password">{{errors.password}}</small>
          </input-group>
        </div>
      </div>



      <div class="mt-3 text-right">
        <div class="submit-wrapper text-right">
          <primary-button type="submit" :full-width="false" cta>
          {{ $t('buttons.create_account') }}
          </primary-button>
        </div>
      </div>
    </form>
  </modal>
</template>

<script>
import Modal                from '@/components/modal/ModalRegular.vue'
import InputGroup           from '@/components/input/InputGroup.vue'
import PrimaryButton        from '@/components/buttons/PrimaryButton.vue'
import OutlineButton        from '@/components/buttons/OutlineButton.vue'
import CountrySelect from "@/components/input/CountrySelect";
import StateSelect from "@/components/input/StateSelect";
import {
  // SET_HAS_MEMBERSHIP_ACCESS,
  SET_IS_ERROR
}                           from '@/store/mutationTypes'
import {resetError} from "../../store/utils";

export default {
  data () {
    return {
      user: {
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        country: process.env.FG_DEFAULT_COUNTRY || '',
        state: '',
      },
      errors: {
        firstName: false,
        lastName: false,
        email: false,
        password: false,
        country: false,
        state: false,
      },
      membershipType: null
    }
  },
  computed: {
    stateRequired() {
      return this.askCountryState && this.user.country == 'US';
    },
    askCountryState() {
      return process.env.REGISTER_FORM_ASK_COUNTRY_STATE=="true";
    }
  },
  methods: {
    setCountry(country) {
      this.user.country = country
      this.user.state = !this.stateRequired ? '' : this.user.state
    },
    setState(state) {
      this.user.state = state
    },
    abort() {
      const ticketsUri = this.$store.getters.ticketsUri;
      if (ticketsUri) {
        const url = new URL(ticketsUri, process.env.FG_TICKETS_APP_URL).href;
        window.location = url
      } else {
        window.location = process.env.FG_HOME_URL
      }
      // this.$store.commit(SET_HAS_MEMBERSHIP_ACCESS, false)
      // this.$router.push('/signup')
    },

    check(field) {
      if (field == 'state') {
        if (this.askCountryState) {
          this.user.state = !this.stateRequired ? '' : this.user.state
          this.errors[field] = !this.stateRequired || this.user[field] ? false : this.$t('errors.required')
        }
        return
      }
      if (field == 'country') {
        if (this.askCountryState) {
          this.errors[field] = this.user[field] ? false : this.$t('errors.required')
        }
        return;
      }

      if (field == 'email') {
        this.errors.email = this.user.email.match(/@/) ? false : this.$t('errors.valid_email')
        return
      }
      if (field == 'password') {
        this.errors.password = this.user.password.length >= 5 ? false : this.$t('errors.min_length', {min: 5})
        return
      }

      this.errors[field] = this.user[field] ? false : this.$t('errors.required')
    },

    checkForm (e) {
      e.preventDefault()

      Object.keys(this.user).forEach((field) => {
        this.check(field)
      })

      if (Object.values(this.errors).find(i => i != false) !== undefined) {
        return
      }

      resetError(this.$store.commit);

      let user = this.user;
      if (!this.askCountryState) {
        user = {
          ...user,
          country: null,
          state: null,
        }
      }
      this.$store.dispatch('signUp', user)
        .then(() => {
          if (!this.$route.query.redirect) {
            if (this.$route.params.checkoutId) {
              this.$router.push(`/checkout/${this.$route.params.checkoutId}`)
            } else {
              this.$router.push('/')
            }
          } else {
            this.$router.push(this.$route.query.redirect || '/')
          }
        }, () => {})
    }
  },
  mounted () {
    // Reset any former errors
    this.$store.commit(SET_IS_ERROR, false)
    this.$store.dispatch('listMembershipTypes', {inviteCodes: this.$store.getters.inviteCodes})
      .then(membershipTypes => {
        // this.membershipType = membershipTypes[0]
        // this.$store.dispatch('selectMembershipType', this.membershipType)
      }, () => {})
  },
  components: {
    Modal,
    InputGroup,
    PrimaryButton,
    OutlineButton,
    CountrySelect,
    StateSelect,
  }
}
</script>

<style lang="scss" scoped>
.button-link {
  margin-top: 15px;

  display: inline-block;
}
.submit-wrapper {
  @media screen and (max-width: map-get($breakpoints, md)) {
    text-align: center;
  }
}
h2 {
  margin-bottom: 4rem;
}

.error {
  color: $error;
  //font-family: $secondary-font-family;
  //font-size: 1rem;
}
</style>

